import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSaintBarthelemy = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_29_1019)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
				fill: "#F0F0F0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M21.426 9.65218H17.4782C17.4782 8.93182 16.8943 8.34784 16.1739 8.34784L15.1304 10.4348C15.1304 10.4348 16.2435 13.5652 16.2087 13.5652H17.513C18.2334 13.5652 18.8173 12.9813 18.8173 12.2609C19.5377 12.2609 20.1217 11.677 20.1217 10.9566H20.0782C20.7986 10.9565 21.426 10.3726 21.426 9.65218Z",
				fill: "#ACABB1"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M2.57391 9.65218H6.52174C6.52174 8.93182 7.10571 8.34784 7.82607 8.34784L8.86957 10.4348C8.86957 10.4348 7.7565 13.5652 7.79131 13.5652H6.48697C5.76657 13.5652 5.18264 12.9813 5.18264 12.2609C4.46223 12.2609 3.8783 11.677 3.8783 10.9566H3.92174C3.20134 10.9565 2.57391 10.3726 2.57391 9.65218Z",
				fill: "#ACABB1"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M16.1739 16.6956V17.2173H7.82605V16.6956H5.73911V18.7826H7.82605V19.3043H16.1739V18.7826H18.2608V16.6956H16.1739Z",
				fill: "#FFDA44"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M7.82605 8.34779V13.5651C7.82605 16.7601 11.9999 17.7391 11.9999 17.7391C11.9999 17.7391 16.1738 16.7601 16.1738 13.5651V8.34779L11.9999 7.82607L7.82605 8.34779Z",
				fill: "#0052B4"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M7.82611 10.435H16.1739V13.5654H7.82611V10.435Z",
				fill: "#D80027"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M14.0869 5.73911V6.52173L13.5652 6.78261L13.0434 6.26084V4.69562H10.9565V6.26084L10.4348 6.78261L9.913 6.52173V5.73911H7.82605V8.34779H16.1739V5.73911H14.0869Z",
				fill: "#FFDA44"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_29_1019",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "white"
		})
	}) })]
});
export default SvgSaintBarthelemy;
